export interface EntityFlags {
	inputWithValues: boolean;
	isProcessed: boolean;
	originContainsUnmatchedSecurities: boolean;
	originContainsFlattenedSleeves: boolean;
	originContainsReallocatedSecurities: boolean;
	originContainsAssetClassSubstitutions: boolean;
	originContainsFixedIncomeSubstitutions: boolean;
	originContainsEditableModel: boolean;
	originShouldReimport: boolean;
	originContainsChildrenPortfolios: boolean;
	originContainsUnsupportedSMA: boolean;
	originContainsUnsupportedManagedModel: boolean;
	originSleeveContainsUnmatchedSecurities: boolean;
}

/**
 * List of flags from the EntityFlags that cause a portfolio to be dirty if true, i.e. has been altered for analysis in AC
 */
export class DirtyFlags {
	public static readonly resetDirtyFlags = {
		originContainsUnmatchedSecurities: false,
		originContainsFlattenedSleeves: false, // old APM flag - should not be used on the FE for any check
		originContainsReallocatedSecurities: false, // old APM flag - should not be used on the FE for any check
		originContainsUnsupportedSMA: false,
		originContainsUnsupportedManagedModel: false,
		originSleeveContainsUnmatchedSecurities: false,
		originContainsAssetClassSubstitutions: false,
		originContainsFixedIncomeSubstitutions: false
	};
}

/**List of new readonly properties and constants */
export class PartnerPortfolioConstants {
	public static readonly UMA_UNSUPPORTED_ERROR_CODES = [
		'CASH_SUBSTITUTED_SECURITIES',
		'CASH_SUBSTITUTED_MANAGED_MODEL',
		'CASH_SUBSTITUTED_SMA',
		'ASSET_CLASS_SUBSTITUTION',
		'MODEL_IS_A_REIMPORT'
	];

	public static readonly MODEL_REIMPORT_LABEL = 'MODEL_IS_A_REIMPORT';

	public static readonly MODEL_REIMPORT_MATCH = 'Yes';

}
